// extracted by mini-css-extract-plugin
export default {"ConnectButton":"ConnectButton_ujJ5G","mint":"mint_KiK3W","connect":"connect_sILAv","connected":"connected_ede1U","noHeader":"noHeader_NhDD3"};